// The Terms of Service and Privacy Policy (apps/web/src/legal): which Terms people have agreed to.

/**
 * The current Terms: their "Last updated" date. A change that matters moves it, and everyone agrees
 * again (and says they're 18 or older) before their next card or server.
 */
export const TERMS_VERSION = '2026-10-27';

/** Agreed to the current Terms. */
export const hasAcceptedTerms = (user: { termsVersion?: string }): boolean => user.termsVersion === TERMS_VERSION;
